import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import iconArrowRightBlue from "../../../../img/icons/arrow_right_blue.svg";
import { useAppDispatch } from "../../../store/reducers";
import { setPanelTriggerState } from "../reducers";

import styles from "./index.module.scss";

const getFooter = () => {
    const document = getDocument();
    return document?.querySelector<HTMLElement>(".site-footer") ?? null;
};

const getPDPHero = () => {
    const document = getDocument();
    return document?.querySelector<HTMLElement>(".pdp-hero") ?? null;
};

export const showFinanceBlock = (): void => {
    const footer = getFooter();
    const PDPHero = getPDPHero();
    if (footer) {
        footer.classList.remove("u-unset-position");
    }
    if (PDPHero) {
        PDPHero.classList.remove("u-increase-z-index");
    }
};
const hideFinanceBlock = (): void => {
    const footer = getFooter();
    const PDPHero = getPDPHero();
    if (footer) {
        footer.classList.add("u-unset-position");
    }
    if (PDPHero) {
        PDPHero.classList.add("u-increase-z-index");
    }
};

export const disableMainConfiguratorScrolling = (): void => {
    const document = getDocument();
    const container = document?.querySelector<HTMLElement>(
        ".pdp-hero .configurator",
    );
    if (container) {
        container.classList.add("overflow-hidden");
    }
};

type IProps = Immutable<{
    prefixNameCapped: string;
    onOpenPanel: () => void;
    children: React.ReactNode;
}>;

export const ConfiguratorPanelTrigger = (props: IProps) => {
    const dispatch = useAppDispatch();
    return (
        <button
            className={styles.button}
            onClick={() => {
                props.onOpenPanel();
                hideFinanceBlock();
                dispatch(setPanelTriggerState({ isClicked: true }));
            }}
        >
            <h6>{props.prefixNameCapped}</h6>
            <span>{props.children}</span>
            <SVG aria-hidden="true" src={iconArrowRightBlue} />
        </button>
    );
};
